/**
 * Parses `filename` from a Content-Disposition header (simple `filename=` token only).
 * Does not handle RFC 5987 `filename*`; extend when a backend requires it. Strips ASCII quotes.
 * Returns `fallback` when missing or parsing fails.
 */
export function getFilenameFromContentDisposition(contentDisposition: string | undefined, fallback: string): string {
  const rawFilename = contentDisposition?.split('filename=')[1]?.split(';')[0];
  return rawFilename ? rawFilename.replace(/^["']|["']$/g, '') : fallback;
}

export function downloadBlobInBrowser(blob: Blob | File, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
